import React, { useRef, useState, useEffect } from "react";
import ScrollMenu from "react-horizontal-scrolling-menu";
import SvgLeftScrollArrow from "./icons/iconComponents/LeftScrollArrow";
import SvgRightScrollArrow from "./icons/iconComponents/RightScrollArrow";
import "./TopicScroll.css";
import { createFragmentContainer, graphql } from "react-relay";
import { commitLocalUpdate } from "react-relay";
import environment, { updateLocalSetting } from "./Environment";
import { useMediaQuery } from "react-responsive";
import { useTheme } from "./contexts/ThemeContext";
import ChevLeft from "./icons/iconComponents/ChevronLeftIcon";
import ChevRight from "./icons/iconComponents/ChevronRightIcon";

function TopicScroll(props) {
    const containerRef = useRef(null);
    const [buttonPressed, setButtonPressed] = useState(false);
    const { isNavActivated } = props.settings;
    const isSmallScreen = useMediaQuery({
        query: "(max-width: 900px)",
    });

    const theme = useTheme();

    function onBackClick(e) {
        e.preventDefault();
        sideScroll(containerRef, "left", 25, 100, 30);
    }

    function onForwardClick(e) {
        e.preventDefault();
        sideScroll(containerRef, "right", 25, 100, 30);
    }

    function onButtonClick(e) {
        e.preventDefault();
        setButtonPressed(!buttonPressed);
    }

    function onInputChange(e) {
        // e.preventDefault();
        setButtonPressed(!buttonPressed);
        const selectedCategoryId = e.target.value;
        // commitLocalUpdate(environment, store => {
        // 	const record = store.getRoot().getLinkedRecord("settings");
        // 	record.setValue(selectedCategoryId, "categoryId");
        // })

        updateLocalSetting("categoryId", selectedCategoryId);
    }

    function sideScroll(element, direction, speed, distance, step) {
        let scrollAmount = 0;
        var slideTimer = setInterval(function () {
            if (direction == "left") {
                element.current.scrollLeft -= step;
            } else {
                element.current.scrollLeft += step;
            }
            scrollAmount += step;
            if (scrollAmount >= distance) {
                window.clearInterval(slideTimer);
            }
        }, speed);
    }
    return (
        <div>
            {isSmallScreen ? (
                <div
                    className={`xtopic-scroll-container xtopic-scroll-container-false topic-scroll-container-small-screen`}
                >
                    <div ref={containerRef} className="topic-scroll-items-small-screen">
                        {props.scroll_Categories.edges.map((edge, key) => (
                            <div className={`topic-scroll-button-small-screen`} key={key}>
                                <label htmlFor={edge.node.name}>
                                    <input
                                        onChange={onInputChange}
                                        id={edge.node.name}
                                        type="radio"
                                        name="category"
                                        value={edge.node.id}
                                    />
                                    <span>{edge.node.name}</span>
                                </label>
                            </div>
                        ))}
                    </div>
                </div>
            ) : (
                <div
                    className={`topic-scroll-container topic-scroll-container-${isNavActivated}`}
                >
                    <div ref={containerRef} className="">
                        {props.scroll_Categories.edges.map((edge, key) => (
                            <div
                                className={`topic-scroll-button ${theme.paragraph}`}
                                key={key}
                            >
                                <label htmlFor={edge.node.name}>
                                    <input
                                        onChange={onInputChange}
                                        id={edge.node.name}
                                        type="radio"
                                        name="category"
                                        value={edge.node.id}
                                    />
                                    <span>{edge.node.name}</span>
                                </label>
                            </div>
                        ))}
                    </div>
                </div>
            )}{" "}
        </div>
    );
}

export default createFragmentContainer(TopicScroll, {
    scroll_Categories: graphql`
        fragment TopicScroll_scroll_Categories on CategoryNodeConnection {
            edges {
                node {
                    id
                    name
                }
            }
        }
    `,
});
